import { useEffect } from 'react';

interface PreselectParams<T> {
    readonly options: readonly T[];
    readonly hasSelection: boolean;
    readonly onSelect: (option: T) => void;
}

export function usePreselectFirst<T>({
    options,
    hasSelection,
    onSelect,
}: PreselectParams<T>): void {
    const first = options[0];
    useEffect(() => {
        if (!hasSelection && first) {
            onSelect(first);
        }
    }, [hasSelection, first, onSelect]);
}
